import { Core } from "@faire/design-tokens";
import { getSpacingPixels } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Carousel/__internal__/getSpacingPixels";
import { ICarouselStyle } from "@faire/web-api--source/indigofair/data/ICarouselStyle";
export var getCarouselTileSpacing = function(tileSpacing) {
    return tileSpacing ? getSpacingPixels(tileSpacing) : undefined;
};
export var getCarouselLoop = function(loopBehavior) {
    switch(loopBehavior){
        case ICarouselStyle.LoopBehavior.NO_LOOP:
            return {
                mobileAndAbove: false
            };
        case ICarouselStyle.LoopBehavior.INFINITE:
            return {
                mobileAndAbove: true
            };
        default:
            return;
    }
};
export var getCarouselDragFree = function(transitionStyle) {
    switch(transitionStyle){
        case ICarouselStyle.CarouselTransitionStyle.SCROLL:
            return {
                mobileAndAbove: true
            };
        case ICarouselStyle.CarouselTransitionStyle.SNAP:
            return {
                mobileAndAbove: false
            };
        default:
            return;
    }
};
export var getCarouselShowNavigationArrows = function(navigationControl) {
    switch(navigationControl){
        case ICarouselStyle.NavigationControl.NO_CONTROLS:
            return {
                mobileAndAbove: false
            };
        case ICarouselStyle.NavigationControl.ARROWS:
            return {
                mobileAndAbove: true
            };
        default:
            return;
    }
};
export var getCarouselControlsVariant = function(navigationControl) {
    if (navigationControl === ICarouselStyle.NavigationControl.DEFAULT_SECONDARY_NAVIGATION_CONTROL) {
        return Core.text.inverse;
    } else if (navigationControl === ICarouselStyle.NavigationControl.DEFAULT_PRIMARY_NAVIGATION_CONTROL) {
        return Core.text.default;
    } else {
        return undefined;
    }
};
